import styled from "styled-components";

import { FlexDiv } from "@/components/Atoms/Box";
import Typography from "@/foundation/Typography/V2";

export const ElementContainer = styled(FlexDiv)`
  width: 100%;
  padding: 0 15px;
  @media only screen and (max-width: 992px) {
    max-width: 100%;
    margin-bottom: 25px;
  }
`;

export const Wrap = styled(FlexDiv)`
  @media only screen and (max-width: 992px) {
    flex-direction: column;
    justify-content: center;
  }
`;

export const Heading = styled(Typography)`
  @media only screen and (max-width: 767px) {
    max-width: 275px;
    margin: 0 auto;
  }
`;
